var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTradeSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8333 63V60C53.8333 58.4087 53.2012 56.8826 52.076 55.7574C50.9508 54.6321 49.4246 54 47.8333 54H38.5C36.9087 54 35.3826 54.6321 34.2574 55.7574C33.1321 56.8826 32.5 58.4087 32.5 60V63",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 46.6667C46.647 46.6667 49.3333 43.9804 49.3333 40.6667C49.3333 37.353 46.647 34.6667 43.3333 34.6667C40.0195 34.6667 37.3333 37.353 37.3333 40.6667C37.3333 43.9804 40.0195 46.6667 43.3333 46.6667Z",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8333 48.8333L56.8333 51.8333L62.9999 45.5",
    stroke: "#008CB7",
    strokeWidth: 2.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeSingle);
export default __webpack_public_path__ + "static/media/tradeSingle.b3df4abd59703343c91b917fdc4d17a3.svg";
export { ForwardRef as ReactComponent };